export default "<svg class=\"icon\" [ngClass]=\"iconClasses()\" [innerHtml]=\"iconUseTag\"></svg>";